export type SafetyIndexEntry = {
  entry_id: string;
  entry_type: string;
  active?: boolean;
  compound?: string;
  canonical_compound_id?: string;
  gene?: string;
  snp?: string;
  genotype_trigger?: string[];
  phenotype?: string;
  group_name?: string;
  gene_conditions?: unknown;
  compound_effects?: unknown;
  action?: string;
  action_detail?: Record<string, unknown>;
  rationale?: string;
  evidence?: { source?: string; classification?: string; pmid?: string | null; [k: string]: unknown };
  curation?: { tier?: string; reviewer?: string; reviewed_at?: string; [k: string]: unknown };
  [k: string]: unknown;
};

export type SafetyIndexStatus = {
  loaded: boolean;
  schema_version?: string | number;
  last_updated?: string | null;
  entry_count: number;
  active_count: number;
  error?: string | null;
};

export type SafetyIndexResponse = { status: SafetyIndexStatus; entries: SafetyIndexEntry[] };

/** Gene(s) display: single-gene `gene` or the group's gene_conditions keys. */
export function entryGenes(e: SafetyIndexEntry): string {
  if (e.gene) return e.snp ? `${e.gene} (${e.snp})` : e.gene;
  const gc = e.gene_conditions;
  if (Array.isArray(gc)) return gc.map((c) => (c && typeof c === 'object' ? String((c as Record<string, unknown>).gene ?? '') : '')).filter(Boolean).join(', ');
  if (gc && typeof gc === 'object') return Object.keys(gc).join(', ');
  return '—';
}

/** Compound(s) display: single `compound` or the group's compound_effects. */
export function entryCompounds(e: SafetyIndexEntry): string {
  if (e.compound) return e.compound;
  const ce = e.compound_effects;
  if (Array.isArray(ce)) return ce.map((c) => (c && typeof c === 'object' ? String((c as Record<string, unknown>).compound ?? '') : '')).filter(Boolean).join(', ');
  if (ce && typeof ce === 'object') return Object.keys(ce).join(', ');
  return e.group_name || '—';
}

export function filterSafetyEntries(list: SafetyIndexEntry[], query: string): SafetyIndexEntry[] {
  const q = query.toLowerCase().trim();
  if (!q) return list;
  return list.filter((e) =>
    e.entry_id.toLowerCase().includes(q) ||
    (e.entry_type || '').toLowerCase().includes(q) ||
    entryGenes(e).toLowerCase().includes(q) ||
    entryCompounds(e).toLowerCase().includes(q) ||
    (e.action || '').toLowerCase().includes(q));
}
